import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Tees from "./pages/Tees";
import Analysis from "./pages/Analysis";
import Reports from "./pages/Reports";
import Users from "./pages/Users";
import StoreDetail from "./pages/StoreDetail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Layout from "./components/Layout";
import "./App.css";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen bg-[#f5f2eb] flex items-center justify-center bm-eyebrow">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function OwnerOnly({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "owner") return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/tees" element={<Tees />} />
            <Route path="/analysis" element={<Analysis />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/users" element={<OwnerOnly><Users /></OwnerOnly>} />
            <Route path="/store/:outletId" element={<StoreDetail />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
